import "angular";
import "angular-resource";
import AccountService from "./AccountService";
import AccountListFactory from "./AccountListFactory";
import AccountDetailsFactory from "./AccountDetailsFactory";
import LanguageCodeFactory from "../layout/service/factory/LanguageCodeFactory";
import AuthenticationStatusService from "../authentication/AuthenticationStatusService";
import PrimaryPlanFactory from "../plan/PrimaryPlanFactory.js";
import TransactionAccessRetrService from "../layout/service/TransactionAccessRetrService";
import PrimaryPlanTxnAccessService from "../layout/service/primaryPlanTxnAccessService";

const AccountServiceModule = angular
    .module("AccountServiceModule", ["ngResource"])
    .service("accountService", AccountService)
    .factory("accountListFactory", AccountListFactory)
    //Possibly can deprecate accountDetailsFactory
    .factory("accountDetailsFactory", AccountDetailsFactory)
    .factory("LanguageCodeFactory", LanguageCodeFactory)
    .factory("AuthenticationStatusService", AuthenticationStatusService)
    .factory("primaryPlanFactory", PrimaryPlanFactory)
    .factory("TransactionAccessRetrService", TransactionAccessRetrService)
    .factory("PrimaryPlanTxnAccessService", PrimaryPlanTxnAccessService);

export default AccountServiceModule;
